import {useState, useEffect, useCallback} from "react";

//NOTE: useInterval is often appropriate
//however our countdowns often need to stay alive/active even when the tab
//is not active. So we had to move the interval into a worker process.
import {useWorkerProcessInterval as useInterval} from "../use-interval/use-interval";


const defaultFunc = () => {};

const useCountdown = ({
  seconds = 300, //default to 5 minutes
  onComplete = defaultFunc,
  onTick = defaultFunc,
  autoStart = true,
  loop = false

}) => {

  const [remaining, setRemaining] = useState(seconds);

  const onSecondTick = useCallback(() => {
    setRemaining(r => {
      const newRemaining = Math.max(r - 1,0);
      onTick(newRemaining);
      return newRemaining;
    })
  },[onTick]);

  const {stop:stopTicker, restart:restartTicker} = useInterval({milliseconds: 1000, onTrigger:onSecondTick, autoStart});

  const restart = useCallback(() => {
    setRemaining(seconds);
    restartTicker();
  },[restartTicker, seconds])

  useEffect(() => restart(),[seconds, restart]);

  useEffect(() => {
    if (remaining <= 0) {
      onComplete();
      if (!loop) {
        stopTicker();
      } else {
        restart();
      }
    }
  },[loop, onComplete, remaining, restart, stopTicker]);

  return {
    remaining,
    stop:stopTicker,
    restart
  }
}

export default useCountdown;